import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer-wrapper footer-layout1 black-bg space-top">
      <div className="widget-area">
        <div className="container">
          <div className="newsletter-area">
            <div className="newsletter-top">
              <div className="row gy-4 align-items-center">
                <div className="col-lg-5">
                  <h2 className="newsletter-title text-white text-capitalize mb-0">
                    Get updated with the latest newsletter
                  </h2>
                </div>
                <div className="col-lg-7">
                  <form className="newsletter-form">
                    <input className="form-control" type="email" placeholder="Enter Email" required />
                    <button type="submit" className="th-btn style3">
                      Subscribe Now <img src="assets/img/icon/plane.svg" alt="Send icon" />
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <div className="row justify-content-between">
            <div className="col-md-6 col-xl-3">
              <div className="widget footer-widget">
                <div className="th-widget-about">
                  <div className="about-logo">
                    <Link to="/">
                      <img src="assets/img/logo3.png" alt="Avighna logo" />
                    </Link>
                  </div>
                  <p className="about-text">
                    Rapidiously myocardinate cross-platform intellectual capital model.
                    Appropriately create interactive infrastructures.
                  </p>
                  <div className="th-social">
                    <a href="https://www.facebook.com/" target="_blank" rel="noreferrer">
                      <i className="fab fa-facebook-f"></i>
                    </a>
                    <a href="https://www.twitter.com/" target="_blank" rel="noreferrer">
                      <i className="fab fa-twitter"></i>
                    </a>
                    <a href="https://www.linkedin.com/company/avighna-energy-solutions-private-limited/" target="_blank" rel="noreferrer">
                      <i className="fab fa-linkedin-in"></i>
                    </a>
                    <a href="https://www.whatsapp.com/" target="_blank" rel="noreferrer">
                      <i className="fab fa-whatsapp"></i>
                    </a>
                    <a href="https://instagram.com/" target="_blank" rel="noreferrer">
                      <i className="fab fa-instagram"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-xl-auto">
              <div className="widget widget_nav_menu footer-widget">
                <h3 className="widget_title">Useful Link</h3>
                <ul className="menu">
                  <li><Link to="/">Home</Link></li>
                  <li><Link to="/about">About us</Link></li>
                  <li><Link to="/services">Our Service</Link></li>
                  <li><Link to="/contact">Terms of Service</Link></li>
                  <li><Link to="/services">News & Media</Link></li>
                </ul>
              </div>
            </div>

            <div className="col-md-6 col-xl-auto">
              <div className="widget footer-widget">
                <h3 className="widget_title">Get In Touch</h3>
                <div className="th-widget-contact">
                  <div className="info-box_text">
                    <div className="icon">
                      <img src="assets/img/icon/phone.svg" alt="Phone icon" />
                    </div>
                    <div className="details">
                      <p><a href="tel:+919515663614">+91 9515663614</a></p>
                    </div>
                  </div>
                  <div className="info-box_text">
                    <div className="icon">
                      <img src="assets/img/icon/envelope.svg" alt="Email icon" />
                    </div>
                    <div className="details">
                      <p><a href="mailto:info@avighnaespl.com">info@avighnaespl.com</a></p>
                      <p><a href="mailto:support@avighnaespl.com">support@avighnaespl.com</a></p>
                    </div>
                  </div>
                  <div className="info-box_text">
                    <div className="icon">
                      <img src="assets/img/icon/location-dot.svg" alt="Location icon" />
                    </div>
                    <div className="details">
                      <p>
                        <a
                          href="https://maps.app.goo.gl/QyH2fFoJ9fii93mt7"
                          target="_blank"
                          rel="noreferrer"
                        >
                          A Block, Ardente Office One,<br />
                          Hoodi Main Rd, Hoodi,<br />
                          Bengaluru, Karnataka 560048
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-xl-auto">
              <div className="widget footer-widget">
                <h3 className="widget_title">Instagram Post</h3>
                <div className="sidebar-gallery">
                  {[1, 2, 3, 4, 5, 6].map((num) => (
                    <div className="gallery-thumb" key={num}>
                      <img src={`assets/img/widget/gallery_1_${num}.jpg`} alt="" />
                      <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://www.instagram.com/"
                        className="gallery-btn"
                      >
                        <i className="fab fa-instagram"></i>
                      </a>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="copyright-wrap">
        <div className="container">
          <div className="row justify-content-lg-between align-items-center">
            <div className="col-lg-6">
              <p className="copyright-text">
                Copyright © 2025 <Link to="/">Avighna</Link>. All Rights Reserved.
              </p>
            </div>
            <div className="col-lg-6 text-center text-lg-end">
              <ul className="footer-links">
                <li><Link to="/about">Terms & Conditions</Link></li>
                <li><Link to="/career">Careers</Link></li>
                <li><Link to="/about">Privacy Policy</Link></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
